import { render, staticRenderFns } from "./assess-scroll-tab.vue?vue&type=template&id=042acccc&scoped=true"
import script from "./assess-scroll-tab.vue?vue&type=script&lang=js"
export * from "./assess-scroll-tab.vue?vue&type=script&lang=js"
import style0 from "./assess-scroll-tab.vue?vue&type=style&index=0&id=042acccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042acccc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default,CommonButton: require('/builds/wj/fe/wenjuan-homesite/components/common/button.vue').default,CommonGridRow: require('/builds/wj/fe/wenjuan-homesite/components/common/grid-row.vue').default})
